export const AUTH_PARENT_QUERY_PARAMS = {
    SIGN_UP: 'signup',
    SIGN_IN_PARENT: 'signin',
    SIGN_IN_TEEN: 'signin-teen',
    INVITATION_CODE: 'invitation_code',
    REFERRAL_CODE: 'referral_code'
} as const;